import { render, staticRenderFns } from "./feedBackPage.vue?vue&type=template&id=931c1592&scoped=true&"
import script from "./feedBackPage.vue?vue&type=script&lang=js&"
export * from "./feedBackPage.vue?vue&type=script&lang=js&"
import style0 from "./feedBackPage.vue?vue&type=style&index=0&id=931c1592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931c1592",
  null
  
)

export default component.exports